import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { ExpenseTypeNone } from '@app/enums/ExpenseTypes';
import { ReimbursementRequestService } from '@app/v2/services/reimbursement-request/reimbursement-request.service';
import { UserServiceV2 } from '@app/v2/services/user-service/user.service';
import { Expense } from '@models/request';
import { StudyStateService } from '@services/state-management/study-state.service';
import { isTypeMileageExpense } from '@utility/utility';
import { combineLatest, filter, map } from 'rxjs';
import { MileageExpenseViewComponent } from '../mileage-expense-view/mileage-expense-view.component';
import { OtherExpenseViewComponent } from '../other-expense-view/other-expense-view.component';

@Component({
    selector: 'medpace-expense-view',
    imports: [AsyncPipe, MileageExpenseViewComponent, OtherExpenseViewComponent],
    templateUrl: './expense-view.component.html',
    styleUrl: './expense-view.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ExpenseViewComponent {
    expense = input.required<Expense>();
    index = input.required<number>();

    expense$ = toObservable(this.expense).pipe(filter(Boolean));
    studyStateService = inject(StudyStateService);
    userService = inject(UserServiceV2);
    elevatedAccess$ = this.userService.permissions.request.access.elevated$;
    isInProcessOrHigher$ = inject(ReimbursementRequestService).isInProcessOrHigher$;
    expenseType$ = combineLatest({
        expense: this.expense$,
        availableExpenses: this.studyStateService.getAvailableExpenses(),
    }).pipe(
        map(({ availableExpenses, expense }) => {
            return (
                availableExpenses?.find((e) => e.expenseId == expense.expenseId)?.expenseDefaultValue ??
                ExpenseTypeNone.viewValue
            );
        })
    );
    isTypeMileageExpense = computed(() => {
        return this.expense() ? isTypeMileageExpense(this.expense().expenseId) : undefined;
    });
}
